import React, { FC, useEffect, useState } from "react";
import axiosInstant from "../../../../api";
import { SingleFilter } from "./singleFilter";
import { ISingleOption, getFilterProps } from "./helper";
import { ProductV2Modal } from "../../productsV2/productModal";
import { useUser } from "../../../../hooks/useUser";
import { isInternal } from "../../../../utils";
import { IconProduct } from "../../../../utils/icons";
import { useWorkspaceBrandId } from '../../../../hooks/useWorkspaceBrandId';

interface IProduct {
  desireid: number;
  title: string;
  image?: string;
}

interface Props {
  onFilterSelect: (key: string, id?: string) => void;
  creatable?: boolean;
  queryParams?: any;
  options?: Array<ISingleOption>;
}

export const ProductFilter: FC<Props> = ({
  creatable,
  onFilterSelect,
  queryParams,
  options,
  ...rest
}) => {
  const { role, brand } = useUser();
  const workspaceBrandId = useWorkspaceBrandId();
  const brandId: number = workspaceBrandId || (brand ? brand[0].id : 0);
  const [isCreateModalShown, showCreateModal] = useState(false);
  const [internalProducts, setInternalProducts] = useState<
    Array<ISingleOption>
  >([]);

  const fetchProducts = () => {
    let endpoint = `/brands/${brandId}/products?limit=100&page=1`;
    if (isInternal(role)) {
      endpoint = `/products?all=true&${queryParams}`;
    }
    axiosInstant
      .get(endpoint)
      .then((response) => {
        const output = response.data.rows.map((e: IProduct) => {
          if (!e.desireid || !e.title) return null;
          return {
            id: e.desireid,
            name: e.title,
            image: e.image,
            icon: IconProduct({
              width: 24,
              height: 24,
              customStyles: { minWidth: 24 },
            }),
          };
        });
        setInternalProducts(output.filter((e: ISingleOption) => !!e));
      })
      .catch((error) => {
        console.error(error.response);
      });
  };

  useEffect(() => {
    if (!options) {
      fetchProducts();
    }
  }, [options]);

  const productsList = options || internalProducts;

  return (
    <>
      <SingleFilter
        {...rest}
        {...getFilterProps(productsList, "productId")}
        updateSearch={onFilterSelect}
        thumbnails
        icon={IconProduct}
        onCreateNew={creatable ? () => showCreateModal(true) : undefined}
      />
      {isCreateModalShown && (
        <ProductV2Modal
          onClose={() => showCreateModal(false)}
          onComplete={() => {
            showCreateModal(false);
            fetchProducts();
          }}
        />
      )}
    </>
  );
};
